export default "__VITE_ASSET__ae35cd17__"